<template>
    <div class="mt-6 p-6 border rounded shadow">
        <div class="w-full text-center bg-blue-600 font-thin text-gray-200 py-2 mb-2">
            Scegli l'utente
        </div>
        <div class="w-full relative mb-6">
            <select name="users"
                    id="users"
                    class="w-full block appearance-none bg-gray-100 border-b rounded-none border-gray-700 text-gray-700 px-4 py-2 pr-8"
                    v-model="selected"
            >
                <option v-for="user in users" :value="user">{{ user.username }}</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                </svg>
            </div>
        </div>
        <div class="w-full text-center font-thin text-gray-700 mb-6">
            Attiva/Disattiva le Notifiche
        </div>
        <ul class="list-reset">
            <li class="flex justify-between mb-2"
                v-for="subscription in subscriptions"
            >
                <div>
                    {{ subscription.name }}
                </div>
                <toggle-subscription :subscription="subscription.id"
                                     :user="selected"
                                     @subscription-changed="fetchUsers"
                ></toggle-subscription>
            </li>
        </ul>

    </div>
</template>

<script>
    import ToggleSubscription from './ToggleSubscription';

    export default {
        components: {ToggleSubscription},

        data() {
            return {
                subscriptions: {},
                users: {},
                selected: {},
            }
        },

        mounted() {
            axios.get('/subscriptions').then(({data}) => this.subscriptions = data);
            this.fetchUsers();
        },

        methods: {
            subscribe(id) {
                axios.post(`/subscriptions/${id}/subscribe`, {user_id: this.selected.id})
                    .then(() => {
                        console.log('BoomBaby')
                    })
            },

            fetchUsers() {
                axios.get('/api/users').then(({data}) => this.users = data);
            }
        }

    }
</script>
